<template lang="html">
  <div class="">
    <div :style="{'marginTop': height + 'px'}" />
    <transition name="slide">
      <b-navbar
        v-if="visible"
        @mouseleave="handleScroll(false)"
        :style="{ height: height + 'px' }"
        fixed="top">
        <div class="d-none d-sm-none d-md-block">
          <b-navbar-brand href="#">
            <img
            alt="AXIOX"
            src="../assets/img/logo/small.svg"
            @click="goToHref('video')"
            />
          </b-navbar-brand>
        </div>
        <div class="menu-button d-block d-sm-block d-md-none">
          <MenuButton v-if="collapse" :callback="() => {this.collapse = !this.collapse}" />
          <img
          v-else
          alt="AXIOX"
          id="logo"
          src="../assets/img/logo/small.svg"
          @click="collapse = !collapse"
          />
        </div>
        <div class="menu-button d-none d-sm-none d-md-block">
          <MenuButton :callback="() => {this.collapse = !this.collapse}" />
        </div>
        <b-collapse id="collapse" v-model="collapse" class="mt-2">
            <ul id="menu">
              <li class="link-button" v-for="(link, i) in links" :key="`link${i}`">
                <a @click="clickOnMenu(link.href)">{{link.label}}</a>
              </li>
            </ul>
        </b-collapse>
        <b-navbar-nav class="ml-auto d-none d-sm-none d-md-block">
          <Button @click.native="goToHref('contacts')">Связаться с нами</Button>
        </b-navbar-nav>
      </b-navbar>
    </transition>
  </div>
</template>

<script>
import Button from '../components/Button.vue'
import MenuButton from '../components/MenuButton.vue'

const HEADER_SIZE = 100;

export default {
  components: {
    Button,
    MenuButton
  },
  props: ['links'],
  data: () => ({
    visible: true,
    collapse: false,
    height: HEADER_SIZE,
    lastScrollTop: 0
  }),
  methods: {
    headerSize () {
      return window.innerWidth > 800 ? 100 : 80
    },
    directionToDown(st) {
      let direction = (this.lastScrollTop > st);
      this.lastScrollTop = st <= 0 ? 0 : st;
      return direction;
    },
    handleScroll(state) {
      let offset = window.pageYOffset;
      this.collapse = false;
      if (offset > (window.innerHeight - this.headerSize())) {
        this.height = this.headerSize() - 20;
        setTimeout(() => {
          this.visible = typeof(state) === 'boolean' ? state : this.directionToDown(offset);
        }, 100);
      } else {
        this.height = this.headerSize();
        this.visible = true;
      }
      // this.height = offset > window.innerHeight ? 80 : 100;
    },
    handleResize() {
      this.height = this.headerSize();
    },
    handleMousemove(event) {
      if (!this.visible) this.visible = event.clientY < (this.headerSize() / 2)
    },
    clickOnMenu(href) {
      this.goToHref(href);
      this.collapse = false;
    },
    goToHref(href) {
      let element = document.getElementsByName(href)[0];
      element.scrollIntoView({behavior: "smooth"});
    }
  },
  created () {
    this.height = this.headerSize();
    // Polyfil
    Object.defineProperty(window, 'pageYOffset', {
      get: function() {
        return document.documentElement.scrollTop;
      }
    });
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('mousemove', this.handleMousemove);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('mousemove', this.handleMousemove);
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="css" scoped>
  .menu-button {
    margin: auto;
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  #logo {
    width: 80%;
    margin: 0 10%;
  }
  #collapse {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    margin-top: 0 !important;
    text-align: center;
    background-color: rgba(24,23,26, 0.9);
    padding-bottom: 10px;
  }
  #menu {
    margin: 30px;
    padding: 0;
    list-style-type: none;
  }
  #menu li {
    margin: 18px;
  }
  #menu li a {
    font-size: 1.6rem;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
  }
  #menu li a:hover {
    color: #868686;
  }
  .navbar {
    padding: 1rem 10%;
    background-color: #18171a;
    transition: .3s;
  }
  .slide-enter-active, .slide-leave-active {
    transition: all .3s ease;
  }
  .slide-enter, .slide-leave-to {
    transform: translateY(-100px);
    /* opacity: 0; */
  }
</style>
